import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import RoofRepair from "@/pages/services/RoofRepair";

export const Route = createFileRoute("/_site/services/roof-repair")({
  head: () => ({
    ...seo({
      title: "Roof Repair Services | Kodiak Structures & Exteriors",
      description:
        "Fast, reliable roof repair throughout Minnesota. Leak repair, storm damage, missing shingles — Kodiak responds 24/7 for emergencies.",
      path: "/services/roof-repair",
    }),
  }),
  component: RoofRepair,
});
